
import { Component, mixins, Prop } from 'nuxt-property-decorator';
import SanityBlockContentMixin from '~/mixins/SanityBlockContent';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';

interface IExpandableTextProps {
  readLessLabel?: string;
  readLessAriaLabel?: string;
  readMoreLabel?: string;
  readMoreAriaLabel?: string;
}

type TBlockWithUnknownType = { _type: string };

type TDocWithTitle = ISanityDocuments[SanityDocumentSchema] & {
  title?: string;
};

@Component
export default class SanityBlockContent extends mixins(
  SanityBlockContentMixin,
) {
  @Prop(Object) readonly doc!: TDocWithTitle;

  isFullTextExpanded = false;
  translationPathPrefix = `components.sanity.sanityBlockContentExpandable`;

  get ariaLabel() {
    if (this.isFullTextExpanded) {
      return this.expandableTextProps?.readLessAriaLabel &&
        this.expandableTextProps?.readLessLabel
        ? this.expandableTextProps.readLessAriaLabel
        : this.expandableTextProps?.readLessLabel || this.doc?.title
        ? this.$t(`${this.translationPathPrefix}.readLessWithTitle`, {
            title: this.doc.title,
          })
        : this.$t(`${this.translationPathPrefix}.readLess`);
    } else {
      return this.expandableTextProps?.readMoreAriaLabel &&
        this.expandableTextProps?.readMoreLabel
        ? this.expandableTextProps?.readMoreAriaLabel
        : this.expandableTextProps?.readMoreLabel || this.doc?.title
        ? this.$t(`${this.translationPathPrefix}.readMoreWithTitle`, {
            title: this.doc.title,
          })
        : this.$t(`${this.translationPathPrefix}.readMore`);
    }
  }

  get activatorAttrs() {
    return {
      id: this.$id('expand-text-activator'),
      ['aria-expanded']: this.isFullTextExpanded ? 'true' : 'false',
      ['aria-controls']: this.$id('expandable-text'),
    };
  }

  get activatorEvents() {
    return {
      click: this.handleClick,
    };
  }

  get expandableTextProps() {
    if (!this.hasFullTextSplit) {
      return {};
    }
    return this.blocks[this.fullTextSplitAt] as IExpandableTextProps;
  }

  get fullTextSplitAt() {
    return this.blocks?.findIndex(
      (block) => (block as TBlockWithUnknownType)._type === 'readMoreDivider',
    );
  }

  get hasFullTextSplit() {
    return (
      this.fullTextSplitAt !== -1 &&
      this.fullTextSplitAt !== this.blocks.length - 1
    );
  }

  get label() {
    if (this.isFullTextExpanded) {
      return (
        this.expandableTextProps?.readLessLabel ||
        this.$t(`${this.translationPathPrefix}.readLess`)
      );
    } else {
      return (
        this.expandableTextProps?.readMoreLabel ||
        this.$t(`${this.translationPathPrefix}.readMore`)
      );
    }
  }

  handleClick() {
    this.isFullTextExpanded = !this.isFullTextExpanded;
  }
}
